import React, { useState } from "react";
import { GrAdd, GrSubtract } from "react-icons/gr";
import { styled } from "@glitz/react";
import { spacing, fontSize, mediumGrey, lightGrey, black } from "../../theme";

type QuantitySelectorProps = {
  initialQuantity?: number;
  onChange?: (quantity: number) => void;
};

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  initialQuantity = 1,
  onChange,
}) => {
  const [quantity, setQuantity] = useState(initialQuantity);

  const updateQuantity = (newQuantity: number) => {
    if (newQuantity < 1) return;
    setQuantity(newQuantity);
    onChange?.(newQuantity);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "58px",
      }}
    >
      <SubtractButton
        onClick={() => updateQuantity(quantity - 1)}
        disabled={quantity <= 1}
        css={quantity <= 1 && disabledStyles}
      >
        <GrSubtract />
      </SubtractButton>
      <QtyInput
        value={quantity}
        style={{
          height: "-webkit-fill-available",
        }}
        onChange={(e) => {
          const value = parseInt(e.target.value, 10);
          if (!isNaN(value)) updateQuantity(value);
        }}
        min={1}
      />
      <AddButton onClick={() => updateQuantity(quantity + 1)}>
        <GrAdd />
      </AddButton>
    </div>
  );
};
const QtyInput = styled.input({
  width: "50px",
  textAlign: "center",
  fontSize: fontSize.m,
  padding: { xy: spacing.xs },

  border: {
    top: { style: "solid", width: "1px", color: black },
    bottom: { style: "solid", width: "1px", color: black },
    left: { style: "none" },
    right: { style: "none" },
  },
});

const QtyButton = styled.button({
  padding: { x: spacing.s, y: spacing.xs },
  fontSize: fontSize.l,
  cursor: "pointer",
  backgroundColor: mediumGrey,
  border: { xy: { color: black, width: "1px", style: "solid" } },
  height: "100%",
});

const SubtractButton = styled(QtyButton, {
  borderTopLeftRadius: "4px",
  borderBottomLeftRadius: "4px",
});

const AddButton = styled(QtyButton, {
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
});

const disabledStyles = styled({
  backgroundColor: lightGrey,
});

export default QuantitySelector;
